import Vue from "vue";

export const NAME_SHOW_SUBMIT_DIALOG = "show-submit-dialog";
export const EVENT_BUS = new Vue();
